import { db } from './firebase'
import snapshotParser from '../helpers/snapshotparser'

export const getConfig = async () => {
  try {
    const snap = await db.doc('config/main').get()
    if (!snap.exists) return false
    const config = snapshotParser(snap)
    return config
  } catch (error) {
    return false
  }
}

export const updateOrderViewType = async viewType => {
  try {
    var currenTConfig = await getConfig()
    currenTConfig = currenTConfig || {}
    const ordersConfig = currenTConfig.orders || {}
    const newState = {
      ...currenTConfig,
      orders: {
        ...ordersConfig,
        type: viewType
      }
    }
    await db.doc('config/main').set(newState)
  } catch (error) {
    console.error(error)
  }
}

export const updateAppointmentInterval = async minutes => {
  try {
    const minutesParsed = parseInt(minutes)
    await db.doc('config/main').update({ appointmentInterval: minutesParsed })
    return true
  } catch (error) {
    console.log('updateAppointmentIntervalError', error)
    return false
  }
}

export default {
  getConfig,
  updateOrderViewType,
  updateAppointmentInterval
}
